<template>
  <div id="app" class="app" v-if="!isLoading">
    <AlertBanner/>
    <router-view name="sidebar"></router-view>
    <router-view name="header"></router-view>
    <transition name="router" mode="out-in">
      <router-view class="view router-view"></router-view>
    </transition>
    <router-view name="footer"></router-view>
  </div>
  <Loader v-else/>
</template>

<script>
import Vue from 'vue';
import Loader from './components/Loader';
import AlertBanner from './components/AlertBanner.vue';
import {
  mapActions,
  mapGetters
} from 'vuex'
export default {
  name: 'App',
  components: {
    Loader,
    AlertBanner
  },
  computed: {
    ...mapGetters({
      isLoading: 'isLoading'
    }),
    hasSidebar() {
      return this.$route.matched.some(record => record.components && record.components.sidebar);
    }
  },
  beforeCreate() {
    if (!localStorage.getItem('locale')) {
      localStorage.setItem('locale', this.$i18n.locale);
    } else {
      this.$i18n.locale = localStorage.getItem('locale');
    }
    Vue.http.headers.common['X-Locale'] = this.$i18n.locale;
  }
}
</script>

<style lang="css">
html,
body {
  height: 100%;
}
.app {
  min-height: 100%;
}
.router-view {
  transition: all .5s ease;
}
.router-enter, .router-leave {
  opacity: 0;
  transform: translate3d(20px, 0, 0);
}
</style>
